import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { Enable2FAData } from '../models';

export interface AuthApi {
  enable2fa(): Observable<Enable2FAData>;
  verifyCode(code: string): Observable<void>;
  resetCode(recoveryCode: string): Observable<void>;
  remove2fa(): Observable<void>;
  logout(): Observable<void>;
}

export const AUTH_API = new InjectionToken<AuthApi>('AUTH_API');
